import React from "react";
import ModalHeader from "@/customComponents/uiComponents/modal/ModalHeader.jsx";
import {img} from "@/utils/pluginImg.js";

/**
 * "Why this pickup time?" — breakdown, monitoring note and total.
 *
 * Dual-mode like the other nested popups: desktop renders PickupWhyContent inside an
 * inline `.upper-modal` (smartPickupResult), mobile pushes this step as a stacked modal
 * (POPUP_STEPS). On /confirm and /edit, SmartPickupFlow opens it as its own sheet
 * (onOpenWhy). The rows/total are computed by smartPickupResult, so the booking flow
 * hands them over through this module-level store right before opening the step.
 */
let whyData = null;

export const setPickupWhyData = (data) => {
    whyData = data;
};

export function PickupWhyContent({data, onLiability, onFindingDriver}) {
    const {isFromAirport, note, airportLabel, flightTimeLabel, rows, totalLabel} = data;

    return (
        <div className="hopn-rp hopn-rp-why-view modalPages-spacing padding-bottom-30">
            <div className="hopn-rp-why">
                <h4>Why this pickup time?</h4>
                <div className="hopn-rp-why-body">
                    <p className="hopn-rp-why-note">{note}</p>

                    <ul className="hopn-rp-breakdown">
                        {rows.map((row, i) => (
                            <li key={i}>
                                <span className="hopn-rp-bd-icon">
                                    <img src={img(row.icon)} alt=""/>
                                </span>
                                <div className="hopn-rp-bd-label">
                                    <b>{row.label}</b>
                                    {row.note && <small>{row.note}</small>}
                                </div>
                                <span className={`hopn-rp-bd-value ${row.negative ? "is-negative" : ""}`}>{row.value}</span>
                            </li>
                        ))}
                    </ul>
                    <div className="hopn-rp-total">
                        <span><strong>Total</strong> estimated time at airport:</span>
                        <strong className="hopn-rp-total-value">
                            {isFromAirport ? `${totalLabel} after landing` : `${totalLabel} before departure`}
                            <button type="button" className="hopn-info-icon" onClick={onLiability}>
                                <img src={img("info-icon.svg")} alt="Liability disclaimer"/>
                            </button>
                        </strong>
                    </div>

                    <div className="hopn-rp-monitor">
                        <span className="hopn-rp-monitor-icon">
                            <img src={img("success-shild.svg")} alt=""/>
                        </span>
                        <p>
                            {isFromAirport ? (
                                <>We'll be there when you land at <strong>{airportLabel}</strong> for your <strong>{flightTimeLabel}</strong> arrival.</>
                            ) : (
                                <>To reach <strong>{airportLabel}</strong> comfortably for your <strong>{flightTimeLabel}</strong> flight.</>
                            )}
                            {isFromAirport && (
                                <button type="button" className="hopn-rp-monitor-link" onClick={onFindingDriver}>
                                    How to find my driver
                                </button>
                            )}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}

// Mobile step. ✕ pops the overlay back to the recommended-pickup screen.
export function SmartPickupWhy(props) {
    return (
        <>
            <ModalHeader
                title=""
                extraClasses=""
                totalSteps={0}
                cancelButton={true}
                cancelButtonType="icon"
                showBackButton={false}
                setStep={props.setStep}
                closeModal={props.closeModal}
            />
            {whyData && (
                <PickupWhyContent
                    data={whyData}
                    onLiability={() => props.setStep("liabilityDisclaimer")}
                    onFindingDriver={() => props.setStep("findingDriver")}
                />
            )}
        </>
    );
}

export default SmartPickupWhy;
